import styled from 'styled-components'

export const ContentDetailsSectionWrapper = styled.div`
  padding: 6rem 0;
`

export const ContentDetailsSectionContainer = styled.div`
  background: white;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;

  @media only screen and (max-width: 900px) {
    display: block;

    & > *:first-child {
      margin-bottom: 3rem;
    }
  }
`

export const ContentDetailsItemsContainer = styled.div`
  width: 100%;
  margin-left: 3rem;

  @media only screen and (max-width: 900px) {
    margin: 0;
  }
`
